import { Routes, Route } from "react-router-dom";
import { OSCI0403001Q } from "@/tz/go/egaz/osci/colt/cncl/OSCI0403001Q";
import { OSCI0403002Q } from "@/tz/go/egaz/osci/colt/cncl/OSCI0403002Q";
import { OSCI0403003S } from "@/tz/go/egaz/osci/colt/cncl/OSCI0403003S";
import { OSCI0403004Q } from "@/tz/go/egaz/osci/colt/reus/OSCI0403004Q";
import { OSCI0403005Q } from "@/tz/go/egaz/osci/colt/reus/OSCI0403005Q";
import { OSCI0403006S } from "@/tz/go/egaz/osci/colt/reus/OSCI0403006S";
import { OSCI0403007S } from "@/tz/go/egaz/osci/colt/reus/OSCI0403007S";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 */

export const CnclRouter = () => {
    return (
        <Routes>
            <Route path="/osci0403001q" element={<OSCI0403001Q />} />
            <Route path="/osci0403002q/:bllMgmtId" element={<OSCI0403002Q />} />
            <Route path="/osci0403002q/:bllMgmtId/:aprvYn" element={<OSCI0403002Q />} />
            <Route path="/osci0403003s/:mode" element={<OSCI0403003S />} />
            <Route path="/osci0403003s/:mode/:bllMgmtId" element={<OSCI0403003S />} />
            <Route path="/osci0403004q" element={<OSCI0403004Q />} />
            <Route path="/osci0403005q/:bllMgmtId" element={<OSCI0403005Q />} />
            <Route path="/osci0403005q/:bllMgmtId/:aprvYn" element={<OSCI0403005Q />} />
            <Route path="/osci0403006s/:mode" element={<OSCI0403006S />} />
            <Route path="/osci0403006s/:mode/:bllMgmtId" element={<OSCI0403006S />} />
            <Route path="/osci0403007s" element={<OSCI0403007S />} />
            <Route path="/osci0403007s/:bllMgmtId" element={<OSCI0403007S />} />
            <Route path="/osci0403007s/:bllMgmtId/:scrnId" element={<OSCI0403007S />} />
        </Routes>
    );
};
